type Grouper<T> = (item: T) => string;

/* Group Array of JavaScript Objects by Key or Property Value */
export function groupBy<T>(
  items: T[],
  getGroup: Grouper<T>,
): { [group: string]: T[] } {
  return items.reduce((rv: { [group: string]: T[] }, x) => {
    const group = getGroup(x);
    (rv[group] = rv[group] || []).push(x);
    return rv;
  }, {});
}
